<script lang="ts">
	import { saveEnergyStore } from '$lib/stores/save-energy.store';
	import Image from '$lib/Image.svelte';
	import { getTranslate } from '@tolgee/svelte';
	import PrimaryButton from '$lib/buttons/PrimaryButton.svelte';
	import { draw, fade } from 'svelte/transition';
	import posthog from 'posthog-js';

	let usedClickOnce = false;

	const t = getTranslate();
</script>

<section class="bg-white x-wrapper grid md:grid-cols-4 place-items-center gap-y-8 my-24 mx-auto">
	<div class="col-span-2 max-w-xl flex flex-col gap-6">
		<h2 class="text-4xl font-extrabold text-gray-900 leading-tight">
			{$t('save_energy_title')}
		</h2>
		<p class="text-xl text-gray-500">
			{$t('save_energy_description')}
		</p>
	</div>
	<div class="relative col-span-3 md:col-span-2{$saveEnergyStore ? ' z-50' : ''}">
		<Image fileName="save-energy.webp" sizeFactor="0.75" class="max-w-xs relative" />
		<div
			class="w-[16rem] mr-8 h-48 flex flex-col gap-2 justify-end rounded-lg absolute top-1/3 p-3 bg-accent-dark-bg right-0"
		>
			<div class="flex-1">
				<h4 class="text-lg font-extrabold text-accent-primary">
					{$t('save_energy_phone_headline')}
				</h4>
				<p class="text-sm text-white">
					{$t('save_energy_phone_description')}
				</p>
			</div>
			<PrimaryButton
				hover={false}
				on:click={() => {
					if (!usedClickOnce) {
						posthog.capture('save-energy');
					}
					saveEnergyStore.update((last) => !last);
					usedClickOnce = true;
				}}
				grow
			>
				{#if $saveEnergyStore}
					{$t('save_energy_turn_on')}
				{:else}
					{$t('save_energy_turn_off')}
				{/if}
			</PrimaryButton>
		</div>
		{#if !usedClickOnce}
			<svg
				width="250"
				height="167"
				viewBox="0 0 500 167"
				fill="none"
				class="absolute top-1/3 left-3/4 ml-8 mt-4 pointer-events-none hidden xl:block"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					out:fade={{ duration: 500 }}
					d="M271.16 9.6V21.8H283.04V9.6H289.2V39H283.04V27.24H271.16V39H265V9.6H271.16ZM301.491 18.2V39H295.611V18.2H301.491ZM295.611 9.6H301.491V15.24H295.611V9.6ZM315.835 17.4C317.808 17.4 319.542 17.8533 321.035 18.76C322.528 19.6667 323.675 20.9333 324.475 22.56C325.302 24.1867 325.715 26.0533 325.715 28.16C325.715 28.8533 325.662 29.5867 325.555 30.36H311.395C311.635 31.9333 312.168 33.0667 312.995 33.76C313.822 34.4533 314.915 34.8 316.275 34.8C317.502 34.8 318.515 34.5467 319.315 34.04C320.115 33.5067 320.782 32.68 321.315 31.56L325.435 35.36C324.395 36.7733 323.075 37.84 321.475 38.56C319.875 39.2533 318.075 39.6 316.075 39.6C313.835 39.6 311.888 39.1333 310.235 38.2C308.608 37.2667 307.355 35.9867 306.475 34.36C305.595 32.7067 305.155 30.8133 305.155 28.68C305.155 26.52 305.608 24.5867 306.515 22.88C307.422 21.1467 308.688 19.8 310.315 18.84C311.942 17.88 313.782 17.4 315.835 17.4ZM319.475 26.36C319.502 25.1067 319.182 24.1067 318.515 23.36C317.875 22.5867 316.928 22.2 315.675 22.2C314.555 22.2 313.622 22.5467 312.875 23.24C312.155 23.9067 311.675 24.9467 311.435 26.36H319.475ZM335.593 18.2V21.12C336.739 18.7733 338.419 17.6 340.633 17.6C341.513 17.6 342.286 17.7333 342.953 18V23.72C342.393 23.5333 341.886 23.4 341.433 23.32C341.006 23.24 340.513 23.2 339.953 23.2C338.593 23.2 337.526 23.7333 336.753 24.8C335.979 25.84 335.593 27.24 335.593 29V39H329.713V18.2H335.593ZM362.019 9.6V22.32L372.939 9.6H380.619L369.139 22.68L381.339 39H373.739L364.819 27.04L362.019 30.08V39H355.859V9.6H362.019ZM390.207 9.6V39H384.327V9.6H390.207ZM401.1 18.2V39H395.22V18.2H401.1ZM395.22 9.6H401.1V15.24H395.22V9.6ZM416.084 17.4C418.378 17.4 420.444 17.9733 422.284 19.12C424.124 20.2667 425.391 21.72 426.084 23.48L420.884 26.44C420.698 25.3467 420.151 24.4667 419.244 23.8C418.364 23.1067 417.311 22.76 416.084 22.76C414.538 22.76 413.284 23.2667 412.324 24.28C411.364 25.2667 410.884 26.68 410.884 28.52C410.884 30.3333 411.364 31.7467 412.324 32.76C413.284 33.7467 414.538 34.24 416.084 34.24C417.204 34.24 418.204 33.9067 419.084 33.24C419.964 32.5467 420.538 31.6933 420.804 30.68L425.924 33.56C425.204 35.32 423.964 36.7733 422.204 37.92C420.444 39.04 418.404 39.6 416.084 39.6C413.844 39.6 411.871 39.1333 410.164 38.2C408.458 37.2667 407.124 35.96 406.164 34.28C405.231 32.6 404.764 30.68 404.764 28.52C404.764 26.36 405.244 24.44 406.204 22.76C407.164 21.08 408.498 19.7733 410.204 18.84C411.938 17.88 413.898 17.4 416.084 17.4ZM435.753 9.6V25.16L442.793 18.2H450.713L441.633 27L450.713 39H443.473L437.473 31L435.753 32.68V39H429.873V9.6H435.753ZM461.851 17.4C463.824 17.4 465.557 17.8533 467.051 18.76C468.544 19.6667 469.691 20.9333 470.491 22.56C471.317 24.1867 471.731 26.0533 471.731 28.16C471.731 28.8533 471.677 29.5867 471.571 30.36H457.411C457.651 31.9333 458.184 33.0667 459.011 33.76C459.837 34.4533 460.931 34.8 462.291 34.8C463.517 34.8 464.531 34.5467 465.331 34.04C466.131 33.5067 466.797 32.68 467.331 31.56L471.451 35.36C470.411 36.7733 469.091 37.84 467.491 38.56C465.891 39.2533 464.091 39.6 462.091 39.6C459.851 39.6 457.904 39.1333 456.251 38.2C454.624 37.2667 453.371 35.9867 452.491 34.36C451.611 32.7067 451.171 30.8133 451.171 28.68C451.171 26.52 451.624 24.5867 452.531 22.88C453.437 21.1467 454.704 19.8 456.331 18.84C457.957 17.88 459.797 17.4 461.851 17.4ZM465.491 26.36C465.517 25.1067 465.197 24.1067 464.531 23.36C463.891 22.5867 462.944 22.2 461.691 22.2C460.571 22.2 459.637 22.5467 458.891 23.24C458.171 23.9067 457.691 24.9467 457.451 26.36H465.491ZM481.608 18.2V20.76C482.941 18.52 485.035 17.4 487.888 17.4C490.368 17.4 492.248 18.2267 493.528 19.88C494.808 21.5067 495.448 23.9067 495.448 27.08V39H489.568V27.92C489.568 26.1067 489.288 24.8133 488.728 24.04C488.168 23.24 487.235 22.84 485.928 22.84C484.541 22.84 483.475 23.3067 482.728 24.24C481.981 25.1467 481.608 26.4267 481.608 28.08V39H475.728V18.2H481.608Z"
					fill="#BDFF00"
				/>
				<path
					out:draw={{ duration: 500 }}
					d="M233.5 25C219.004 26.208 201.399 30.1392 187.5 34C180.386 35.9762 172.742 35.5388 165.5 37.4444C154.651 40.2994 144.448 44.8284 133.944 48.5556C107.045 58.1006 83.821 71.5678 63.5 91.8889C52.1753 103.214 44.6103 116.612 35.0556 128.556C26.7067 138.992 30.7674 152.465 25.5 163"
					stroke="#BDFF00"
					stroke-width="5"
					stroke-linecap="round"
				/>
				<path
					out:draw={{ duration: 500 }}
					d="M3 128.5C3.79663 136.466 18.9031 157.629 24 164C27 164 33.8443 161.917 35.8333 161.556C47.7814 159.383 60.3468 158 72.5 158"
					stroke="#BDFF00"
					stroke-width="5"
					stroke-linecap="round"
				/>
			</svg>
		{/if}
	</div>
</section>
